<template>
  <div>
    <AppPreloader v-if="localLoading" />
    <div v-show="!localLoading">
      <slot :loader="withLoading" :localLoading="localLoading" />
    </div>
  </div>
</template>

<script>
import AppPreloader from '@/components/AppPreloader.vue';
import useValidation from '@/compositions/useValidation';

export default {
  name: 'AppWithLoading',
  components: { AppPreloader },
  props: {
    fetch: {
      type: Function,
      default: null,
    },
  },
  setup({ fetch }) {
    const { withLoading, localLoading } = useValidation();

    if (typeof fetch === 'function') {
      withLoading(async () => {
        await fetch();
      });
    }

    return {
      localLoading,
      withLoading,
    };
  },
};
</script>

<style scoped>

</style>
